import { REDUX_OFFER_TYPES } from './action'

const initialState = { offerErrors: {} }

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REDUX_OFFER_TYPES.RESET:
      return initialState
    case REDUX_OFFER_TYPES.SELECTED_OFFER:
      return {
        ...state,
        selectedOffer: action.payload
      }
    case REDUX_OFFER_TYPES.OFFER_ERRORS:
      return {
        ...state,
        offerErrors: action.payload
      }
    case REDUX_OFFER_TYPES.COUNTER_MODE_ON:
      return {
        ...state,
        counterMode: action.payload
      }
    case REDUX_OFFER_TYPES.CURRENT_OFFERS:
      return {
        ...state,
        offers: action.payload
      }
    case REDUX_OFFER_TYPES.OFFER_SENT:
      return {
        ...state,
        isOfferSent: action.payload
      }
    case REDUX_OFFER_TYPES.SHOW_ROUTE_OF:
      return {
        ...state,
        showRouteOf: action.payload
      }
    case REDUX_OFFER_TYPES.OFFERING_TO_LOAD:
      return {
        ...state,
        offeringToLoad: action.payload
      }
    case REDUX_OFFER_TYPES.OFFERING_TO_TRUCK:
      return {
        ...state,
        offeringToTruck: action.payload
      }
    case REDUX_OFFER_TYPES.OFFERING_TO_MATCH:
      return {
        ...state,
        offeringToMatch: action.payload
      }
    default:
      return state
  }
}
